export default function ClosingSection() {
  const handleJump = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="rounded-lg border border-background-300 bg-gradient-to-br from-background-100 to-secondary-50 p-6 md:p-10">
          <div className="max-w-3xl">
            <span className="inline-flex items-center gap-2 text-xs font-medium tracking-wide text-primary-600 uppercase mb-4">
              <i className="ri-flag-2-line"></i>
              最后再总结一次
            </span>
            <h2 className="font-heading font-bold text-foreground-950 text-2xl md:text-3xl leading-snug mb-4">
              把它当“偶尔应急的免费选项”，别当成可信赖的长期平台
            </h2>
            <p className="text-foreground-700 leading-relaxed text-sm md:text-base mb-6">
              神马影院这类第三方影视站，最大的价值是免费和找片方便，最大的短板是可靠性、安全性和稳定性都缺乏保障。
              如果你只是偶尔看看、并且愿意守住“不下载、不授权、不付款”的底线，风险相对可控；但如果你重视内容质量、账号安全和使用省心，
              正规平台才是更合适的答案。归根结底，判断权在你手里，而看清风险，就是做出好判断的第一步。
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <button
                type="button"
                onClick={() => handleJump('risks')}
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-error-warning-line"></i>
                重看风险清单
              </button>
              <button
                type="button"
                onClick={() => handleJump('tips')}
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50 border border-background-300 hover:border-primary-300 text-foreground-800 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-shield-check-line"></i>
                记住使用建议
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}